var map = {
	"./news-7-1.jpg": 96,
	"./news-7-10.jpg": 69146,
	"./news-7-11.jpg": 40311,
	"./news-7-12.jpg": 29384,
	"./news-7-13.jpg": 56997,
	"./news-7-14.jpg": 9662,
	"./news-7-15.jpg": 10971,
	"./news-7-16.jpg": 33996,
	"./news-7-17.jpg": 5609,
	"./news-7-18.jpg": 18450,
	"./news-7-19.jpg": 94831,
	"./news-7-2.jpg": 90415,
	"./news-7-20.jpg": 11007,
	"./news-7-21.jpg": 98338,
	"./news-7-22.jpg": 11245,
	"./news-7-23.jpg": 26672,
	"./news-7-24.jpg": 68323,
	"./news-7-25.jpg": 29798,
	"./news-7-3.jpg": 14034,
	"./news-7-4.jpg": 37633,
	"./news-7-5.jpg": 64036,
	"./news-7-6.jpg": 90259,
	"./news-7-7.jpg": 61846,
	"./news-7-8.jpg": 64485,
	"./news-7-9.jpg": 20520
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 57039;